import React from "react";
import {
    InputLabel,
    styled,
    TextField,
    Autocomplete,
    Modal,
    Typography,
    Box
} from "@mui/material";
import CustomDataGrid from '../../../components/DataGrid'
import { GlobalButton } from "../../styles";

const StyledDiv = styled('div')({
    display: 'flex',
    minHeight: '45vh',
    marginRight: '1rem'
});

const StyledDiVBackGround = styled('div')({
    display: 'flex',
    justifyContent: "space-between",
    backgroundColor: '#1976d2',
    padding: '1rem',
    borderTopRightRadius: '1rem',
    borderTopLeftRadius: '1rem'
});

const StyledDivButtonGroup= styled('div')({
    display: 'flex',
    justifyContent: "space-between", 
    minWidth: '225px'
});

const StyledSpan = styled('span')({
    marginRight: "1rem",
    label:
    {
        color: 'white'
    },
    button:
    {
        backgroundColor: "white",
        color: "#3190D9",
        fontSize: "13px",
        fontFamily: "EMprint",
        textTransform: "none",
        "&:hover": {
            backgroundColor: 'white',
        },
    }
});

const StyledModalBox = styled(Box)(() => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    borderRadius: '10px',
    border: '1px solid rgba(0, 0, 0, 0.3)',
    boxShadow: '0 3px 7px rgba(0, 0, 0, 0.3)',
    backgroundClip: 'padding-box',
    maxHeight: "100%",
    minHeight: '200px'
}));

const StyledModalHeader = styled('div')({
    margin: '15px',
    display: 'flex',
    justifyContent: 'center'
});

const StyledModalBody = styled('div')({
    margin: '2rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem'
});

const MethodManagementDataGridWithClone = ({ title, selectedInfo, addNewFacility, cloneFacility, rows, setRows, cols, sourceFacilityList, targetFacilityList, selectionDataGrid, enableSelect, enableDelete, sx, minWidth, canEdit, childInHeader, enableRowDelete }) => {

    const [openAdd, setOpenAdd] = React.useState(false);
    const [openClone, setOpenClone] = React.useState(false);
    const [sourceFacility, setSourceFacility] = React.useState(null);
    const [targetFacility, setTargetFacility] = React.useState(null);

    function handleChangeAdd(e) {

        let item = targetFacilityList.find(obj => { return obj.text.toString().trim() === e.currentTarget.innerText.trim() });

        addNewFacility({
            ...selectedInfo,
            name: item.value,
            id: item.id
        });
        setOpenAdd(false);
    }

    function handleClone() {
        if (sourceFacility && targetFacility){
            cloneFacility(sourceFacility, targetFacility);
        }
        setOpenClone(false);
    }

    return (

        <div>
            <StyledDiv>
                <div>
                    <StyledSpan>
                        <StyledDiVBackGround>
                            <InputLabel>{title}</InputLabel>
                            <StyledDivButtonGroup>
                                {canEdit && <GlobalButton onClick={() => setOpenAdd(true)}
                                    variant='contained'
                                    type="button"
                                >Add Facility</GlobalButton>
                                }                            
                                {canEdit && <GlobalButton onClick={() => setOpenClone(true)}
                                    variant='contained'
                                    type="button"
                                >Clone Facility</GlobalButton>
                                }                            
                            </StyledDivButtonGroup>
                        </StyledDiVBackGround>
                        <CustomDataGrid key={`datagrid-${title}`} sx={sx} cols={cols} rows={rows} onRowClick={selectionDataGrid} enableSelect={enableSelect} setRows={setRows} minWidth={minWidth} enableDelete={enableDelete} canEdit={canEdit} enableRowDelete={enableRowDelete}></CustomDataGrid>
                    </StyledSpan>
                </div>
            </StyledDiv>

            {
                sourceFacilityList && targetFacilityList && <Modal open={openClone} onClose={() => setOpenClone(false)}>
                    <StyledModalBox>
                        <StyledModalHeader id="modal-modal-header" >
                            <Typography variant="h6" component="h6">Clone Facility</Typography>
                        </StyledModalHeader>
                        <StyledModalBody id="modal-modal-body">     
                            <Typography variant="h6" component="h6">Source Facility</Typography>
                            <Autocomplete
                                disablePortal
                                options={sourceFacilityList.map((label) => label.text.toString())}
                                sx={{ width: "20rem" }}
                                renderInput={(params) => <TextField {...params} />}
                                onChange={e => {
                                    setSourceFacility(e.currentTarget.innerText.trim())
                                }}
                            />
                            <Typography variant="h6" component="h6">Target Facility</Typography>
                            <Autocomplete
                                disablePortal
                                options={targetFacilityList.map((label) => label.text.toString())}
                                sx={{ width: "20rem" }}
                                renderInput={(params) => <TextField {...params} />}
                                onChange={e => {
                                    setTargetFacility(e.currentTarget.innerText.trim())
                                }}
                            />
                            <GlobalButton 
                                onClick={() => handleClone()}
                                variant='contained'
                                type="button"
                                disabled={!targetFacility || !sourceFacility}
                            >
                                Clone
                            </GlobalButton>
                        </StyledModalBody>
                    </StyledModalBox>
                </Modal>
            }
            {
                targetFacilityList && <Modal open={openAdd} onClose={() => setOpenAdd(false)}>
                    <StyledModalBox>
                        <StyledModalHeader id="modal-modal-header" >
                            <Typography variant="h6" component="h6">Add Facility</Typography>
                        </StyledModalHeader>
                        <StyledModalBody id="modal-modal-body">
                            <Autocomplete
                                disablePortal
                                options={targetFacilityList.map((label) => label.text.toString())}
                                sx={{ width: "20rem" }}
                                renderInput={(params) => <TextField {...params} />}
                                onChange={e => {
                                    handleChangeAdd(e)
                                }}
                            />
                        </StyledModalBody>
                    </StyledModalBox>
                </Modal>
            }

        </div>

    );
};

export default MethodManagementDataGridWithClone;
